import User from './User.vue'
import MenuItem from "./../../../core/components/menu/MenuItem";
import i18n from '../../../shared/i18n'

let routes = [{
  path: 'users',
  component: User,
  meta: {
    requiresAuth: true
  }
}];

export default {
  menuItem: new MenuItem('/users', i18n.t('Users'), 40, 'user-friends'),
  routes: routes
}
